<template>
  <v-container class="px-0 ma-0 py-3 lead-activity">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card class="pa-6" rounded="lg" elevation="3">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="card-header mb-4 d-flex align-center justify-space-between"
            >
              <h2>Activities</h2>
              <v-menu offset-y>
                <template #activator="{ props }">
                  <button class="add-activity" v-bind="props">
                    <img :src="addIcon" alt="addIcon" />
                    Add Activity
                  </button>
                </template>

                <v-list>
                  <v-list-item @click="handleAdd('call')">
                    <v-list-item-title>Add Call</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="handleAdd('meeting')">
                    <v-list-item-title>Add Meeting</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="handleAdd('note')">
                    <v-list-item-title>Add Note</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </v-col>
            <v-dialog
              v-model="store.callDialog"
              width="700"
              persistent
              class="add-call-dialog"
            >
              <v-card class="">
                <div
                  class="card-header mb-3 px-4 py-2 d-flex align-center justify-space-between"
                >
                  <div class="d-flex align-center ga-2">
                    <span>
                      <img :src="call_icon" alt="" />
                    </span>
                    <p>Schedule A Call</p>
                  </div>
                  <button @click="store.callDialog = false">
                    <v-icon icon="mdi-close" size="18" color="#237276" />
                  </button>
                </div>
                <div class="card-body px-4 py-2">
                  <v-container class="pa-0 ma-0">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <label for="call_for">Call For</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.data_call.call_for"
                        />
                      </v-col>
                      <v-col cols="6">
                        <label for="number">Number</label>
                        <template v-if="store.data_call.number.length > 0">
                          <div
                            class="mb-1"
                            v-for="(number, index) in store.data_call.number"
                            :key="index"
                          >
                            <v-text-field
                              v-model="number.phone"
                              variant="outlined"
                              density="compact"
                              hide-details
                            ></v-text-field>
                          </div>
                        </template>
                        <template v-else>
                          <div class="mb-1">
                            <v-text-field
                              v-model="store.data_call.phone"
                              variant="outlined"
                              density="compact"
                              hide-details
                            ></v-text-field>
                          </div>
                        </template>
                      </v-col>
                      <v-col cols="6">
                        <label for="status">Call Start Date & Time </label>
                        <VueDatePicker
                          style="width: 95%"
                          v-model="store.data_call.from"
                        >
                        </VueDatePicker>
                      </v-col>
                      <!-- <v-col cols="6">
                        <label for="status">Call End Date & Time </label>

                        <VueDatePicker
                          style="width: 95%"
                          v-model="store.data_call.to"
                        ></VueDatePicker>
                      </v-col> -->
                      <v-col cols="6">
                        <label for="status">Status </label>

                        <v-select
                          v-model="store.data_call.status"
                          :items="store.call_statuses"
                          variant="outlined"
                          hide-details
                          placeholder="Select Status"
                          item-title="title"
                          item-value="value"
                          class="custom-v-select"
                        ></v-select>
                      </v-col>
                      <v-col cols="12">
                        <label for="status">Notes </label>
                        <textarea
                          v-model="store.data_call.content"
                          variant="outlined"
                          hide-details
                          placeholder="Enter Content"
                          rows="5"
                        ></textarea>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-flex align-center justify-end ga-2 pr-3"
                      >
                        <button
                          class="cancel-btn"
                          @click="store.callDialog = false"
                        >
                          Cancel
                        </button>
                        <button
                          v-if="!store.edit_call"
                          class="save-btn"
                          @click="store.createCall($route.params.id)"
                        >
                          Save
                        </button>
                        <button v-else class="save-btn" @click="editCall()">
                          Edit
                        </button>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="store.meetingDialog"
              width="700"
              class="add-call-dialog"
            >
              <v-card class="">
                <div
                  class="card-header mb-3 px-4 py-2 d-flex align-center justify-space-between"
                >
                  <div class="d-flex align-center ga-2">
                    <span>
                      <img :src="call_icon" alt="" />
                    </span>
                    <p>Schedule A Meeting</p>
                  </div>
                  <button @click="store.meetingDialog = false">
                    <v-icon icon="mdi-close" size="18" color="#237276" />
                  </button>
                </div>
                <div class="card-body px-4 py-2">
                  <v-container class="pa-0 ma-0">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <label for="call_for">Meeting For</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="store.data_meeting.meeting_for"
                        />
                      </v-col>
                      <v-col cols="6">
                        <label for="number">Number</label>
                        <template v-if="Array.isArray(store.data_meeting?.number) && store.data_meeting.number.length">
                          <div
                            class="mb-1"
                            v-for="(number, index) in store.data_meeting.number"
                            :key="index"
                          >
                            <v-text-field
                              v-model="number.phone"
                              variant="outlined"
                              density="compact"
                              hide-details
                            ></v-text-field>
                          </div>
                        </template>
                        <template v-else>
                          
                          <div class="mb-1">
                            <v-text-field
                              v-model="store.data_meeting.phone"
                              variant="outlined"
                              density="compact"
                              hide-details
                            ></v-text-field>
                          </div>
                        </template>
                      </v-col>

                      <v-col cols="6">
                        <label for="call_for">Meeting Title</label>
                        <input
                          class="form-control"
                          type="text"
                          v-model="store.data_meeting.meeting_title"
                        />
                      </v-col>
                      <v-col cols="6">
                        <label for="number">Meeting place</label>
                        <input
                          class="form-control"
                          type="text"
                          v-model="store.data_meeting.meeting_place"
                        />
                      </v-col>
                      <v-col cols="6">
                        <label for="status">Meeting Start Date & Time </label>
                        <VueDatePicker
                          style="width: 95%"
                          v-model="store.data_meeting.from"
                          :enable-time="true"
                        >
                        </VueDatePicker>
                      </v-col>
                      <v-col cols="6">
                        <label for="status">Meeting End Date & Time </label>
                        <VueDatePicker
                          style="width: 95%"
                          v-model="store.data_meeting.to"
                          :enable-time="true"
                        ></VueDatePicker>
                      </v-col>
                      <v-col cols="6">
                        <label for="status">Attendees </label>
                        <v-select
                          @click="store.getAgencies()"
                          hide-details
                          return-object
                          :items="store.arr_agency"
                          variant="outlined"
                          class="custom-v-select"
                          placeholder="Select Agency"
                          v-model="store.selectedAgency"
                          no-details
                          clearable
                        >
                          <!-- تخصيص عرض العناصر داخل القائمة -->
                          <template v-slot:item="{ item }">
                            <v-list-item @click="selectedAgency(item)">
                              <div class="d-flex align-center gap-5">
                                <img
                                  :src="item.raw.image"
                                  alt=""
                                  style="
                                    width: 32px;
                                    height: 32px;
                                    border-radius: 50%;
                                    object-fit: cover;
                                    display: flex;
                                  "
                                />
                                <span
                                  style="display: flex; margin-left: 10px"
                                  >{{
                                    item.raw.first_name +
                                    " " +
                                    item.raw.last_name
                                  }}</span
                                >
                              </div>
                            </v-list-item>
                          </template>

                          <!-- تخصيص عرض القيمة المختارة -->
                          <template v-slot:selection="{ item }">
                            <div class="d-flex align-center gap-2">
                              <v-chip
                                variant="outlined"
                                closable
                                @click:close="removeAgency(item)"
                              >
                                <img
                                  :src="item.raw.image"
                                  alt=""
                                  style="
                                    width: 24px;
                                    height: 24px;
                                    border-radius: 50%;
                                    object-fit: cover;
                                    display: flex;
                                  "
                                />
                              </v-chip>
                            </div>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="6">
                        <label for="status">Status </label>
                        <v-select
                          v-model="store.data_meeting.status"
                          :items="store.call_statuses"
                          variant="outlined"
                          hide-details
                          placeholder="Select Status"
                          item-title="title"
                          item-value="value"
                          class="custom-v-select"
                        ></v-select>
                      </v-col>
                      <v-col cols="12">
                        <label for="status">Notes </label>
                        <textarea
                          v-model="store.data_meeting.content"
                          variant="outlined"
                          hide-details
                          placeholder="Enter Content"
                          rows="5"
                        ></textarea>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-flex align-center justify-end ga-2 pr-3"
                      >
                        <button
                          class="cancel-btn"
                          @click="store.meetingDialog = false"
                        >
                          Cancel
                        </button>
                        <button
                          v-if="!store.edit_dialog"
                          class="save-btn"
                          @click="createMeeting($route.params.id)"
                        >
                          Save
                        </button>
                        <button v-else class="save-btn" @click="editMeeting()">
                          Edit
                        </button>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </v-card>
            </v-dialog>

            <v-col cols="12" class="meeting-header mb-3">
              <div class="d-flex align-center ga-3">
                <p class="icon">
                  <img :src="calender" alt="" />
                </p>
                <p class="text">Meeting</p>
              </div>
            </v-col>

            <template
              v-if="
                store.singleLeadData?.overview?.filter(
                  (activity) => activity.type === 'Meeting'
                ).length > 0
              "
            >
              <v-col
                cols="12"
                class="meeting-body mb-3"
                v-for="activity in store?.singleLeadData?.overview?.filter(
                  (activity) => activity.type === 'Meeting'
                )"
                :key="activity.id"
              >
                <v-card class="review-card pa-4" rounded="lg">
                  <!-- Header -->
                  <div class="d-flex align-start justify-space-between">
                    <div class="d-flex align-center ga-3">
                      <div class="user-info d-flex align-center ga-2">
                        <span v-if="store?.singleLeadData?.first_name">
                          {{
                            store.singleLeadData.first_name
                              .slice(0, 1)
                              .toUpperCase()
                          }}
                        </span>
                        <div>
                          <p
                            class="name"
                            v-if="store?.singleLeadData?.first_name"
                          >
                            {{ store?.singleLeadData?.first_name }}
                            {{ store?.singleLeadData?.last_name }}
                          </p>
                          <p class="time">{{ activity.from }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-center ga-2">
                      <div
                        class="text-caption text-medium-emphasis d-flex align-center ga-1"
                      >
                        <v-icon size="16" icon="mdi-clock-outline" />
                        <span>{{ activity.created_at }}</span>
                      </div>

                      <v-menu location="bottom end">
                        <template #activator="{ props }">
                          <v-btn
                            v-bind="props"
                            icon
                            variant="text"
                            size="small"
                          >
                            <v-icon icon="mdi-dots-vertical" />
                          </v-btn>
                        </template>
                        <v-list density="compact">
                          <v-list-item @click="openEditMeetingDialog(activity,store.singleLeadData)">
                            <v-icon
                              size="18"
                              class="mr-2"
                              icon="mdi-pencil-outline"
                            />
                            Edit
                          </v-list-item>
                          
                          <v-list-item
                            @click="
                              store.deleteActivity(
                                activity.activity_id,
                                store.singleLeadData.id
                              )
                            "
                          >
                            <v-icon
                              size="18"
                              class="mr-2"
                              icon="mdi-delete-outline"
                            />
                            Delete
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>
                  <!-- Body -->
                  <div class="mt-3">
                    <p
                      :class="['review-text', { collapsed: !expanded }]"
                      ref="textEl"
                    >
                      {{ activity.content }}
                    </p>
                    <v-divider class="my-3" />
                    <div class="d-flex justify-end">
                      <button class="show-more-btn" @click="toggle">
                        {{ expanded ? "Show Less" : "Show More" }}
                      </button>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </template>

            <template v-else>
              <div class="d-flex justify-center align-center w-100">
                <h3 class="text-center" style="color: #666; font-size: 16px">
                  No Meetings Found
                </h3>
              </div>
            </template>

            <v-col cols="12" class="meeting-header mt-5 mb-3">
              <div class="d-flex align-center ga-3">
                <p class="icon">
                  <img :src="call_icon" alt="" />
                </p>
                <p class="text">Call</p>
              </div>
            </v-col>

            <template
              v-if="
                store.singleLeadData?.overview?.filter(
                  (activity) => activity.type === 'Call Summary'
                ).length > 0
              "
            >
              <v-col
                cols="12"
                class="meeting-body mb-3"
                v-for="activity in store?.singleLeadData?.overview?.filter(
                  (activity) => activity.type === 'Call Summary'
                )"
                :key="activity.id"
              >
                <v-card
                  class="review-card pa-4"
                  rounded="lg"
                  variant="outlined"
                  elevation="1"
                  style="border: none"
                >
                  <!-- Header -->
                  <div class="d-flex align-start justify-space-between">
                    <div class="d-flex align-center ga-3">
                      <div class="user-info d-flex align-center ga-2">
                        <span v-if="store?.singleLeadData?.first_name">
                          {{
                            store.singleLeadData.first_name
                              .slice(0, 1)
                              .toUpperCase()
                          }}
                        </span>
                        <div>
                          <p
                            class="name"
                            v-if="store?.singleLeadData?.first_name"
                          >
                            {{ store?.singleLeadData?.first_name }}
                            {{ store?.singleLeadData?.last_name }}
                          </p>
                          <p class="time">{{ activity.from }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-center ga-2">
                      <div
                        class="text-caption text-medium-emphasis d-flex align-center ga-1"
                      >
                        <v-icon size="16" icon="mdi-clock-outline" />
                        <span>{{ activity.created_at }}</span>
                      </div>

                      <v-menu location="bottom end">
                        <template #activator="{ props }">
                          <v-btn
                            v-bind="props"
                            icon
                            variant="text"
                            size="small"
                          >
                            <v-icon icon="mdi-dots-vertical" />
                          </v-btn>
                        </template>
                        <v-list density="compact">
                          <v-list-item
                            @click="store.openEditCallDialog(activity,store.singleLeadData)"
                          >
                            <v-icon
                              size="18"
                              class="mr-2"
                              icon="mdi-pencil-outline"
                            />
                            Edit
                          </v-list-item>
                          <v-list-item
                            @click="
                              store.deleteActivity(
                                activity.activity_id,
                                store.singleLeadData.id
                              )
                            "
                          >
                            <v-icon
                              size="18"
                              class="mr-2"
                              icon="mdi-delete-outline"
                            />
                            Delete
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>

                  <!-- Body -->
                  <div class="mt-3">
                    <p
                      :class="['review-text', { collapsed: !expanded }]"
                      ref="textEl"
                    >
                      {{ activity.content }}
                    </p>
                    <v-divider class="my-3" />
                    <div class="d-flex justify-end">
                      <button class="show-more-btn" @click="toggle">
                        {{ expanded ? "Show Less" : "Show More" }}
                      </button>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </template>
            <template v-else>
              <div class="d-flex justify-center align-center w-100">
                <h3 class="text-center" style="color: #666; font-size: 16px">
                  No Call Summaries Found
                </h3>
              </div>
            </template>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import addIcon from "@/assets/images/brandify/add_icon.svg";
import calender from "@/assets/images/brandify/calender.svg";
import { useLeadsStore } from "@/store/crm/useLeadsStore";
import call_icon from "@/assets/images/brandify/call_icon.svg";
import VueDatePicker from "@vuepic/vue-datepicker";
import apiClient from "@/core/buildRequest";
import { useGeneralStore } from "@/store/General.js";
export default {
  name: "Activities",
  components: {
    VueDatePicker,
  },
  data() {
    return {
      addIcon,
      genaralStore: useGeneralStore(),
      calender,
      call_icon,
      store: useLeadsStore(),
      expanded: false,
      id: this.$route.params.id,
    };
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
    phoneArrayFrom(obj, listKey = "number", singleKey = "phone") {
      const list = Array.isArray(obj?.[listKey]) ? obj[listKey] : [];
      const fromArray = list
        .map((n) =>
          typeof n === "object" ? n?.phone ?? n?.value ?? n?.number ?? "" : n
        )
        .map((v) => String(v || "").trim())
        .filter(Boolean);

      const fromSingle = obj?.[singleKey]
        ? [String(obj[singleKey]).trim()]
        : [];

      return fromArray.length ? fromArray : fromSingle;
    },

    initMeetingFormForCreate() {
      const lead = this.store.singleLeadData || {};

      const fullName = `${lead.first_name || ""} ${
        lead.last_name || ""
      }`.trim();

      // هات أرقام الـ lead من phones لو Array، وإلا من phone المفرد
      const rawPhones =
        Array.isArray(lead.phones) && lead.phones.length
          ? lead.phones
          : lead.phone
          ? [lead.phone]
          : [];

      const numbers = this.toPhoneObjects(rawPhones); // → [{phone:"..."}]

      this.store.data_meeting = {
        meeting_for: fullName,
        number: numbers, // للـ UI (multi)
        phone: numbers[0]?.phone || "", // fallback لو رقم واحد
        content: "",
        from: "",
        to: "",
        type: "Meeting",
        status: "",
        meeting_place: "",
        meeting_title: "",
        agent_id: Array.isArray(this.store.data_meeting?.agent_id)
          ? this.store.data_meeting.agent_id
          : [],
        agent_id_filter: null,
      };
    },

    handleAdd(type) {
      if (type === "call") {
        this.store.callDialog = true;
        this.store.edit_call = false;
        this.store.edit_dialog = false;
      } else if (type === "meeting") {
        this.initMeetingFormForCreate(); // ← إملا الداتا
        this.store.meetingDialog = true;
        this.store.edit_call = false;
        this.store.edit_dialog = false;
      }
      this.store.getAgencies();
    },
    selectedAgency(item) {
      if (!Array.isArray(this.store.selectedAgency))
        this.store.selectedAgency = [];
      const exists = this.store.selectedAgency.some(
        (a) => (a.id ?? a.raw?.id) === (item.raw?.id ?? item.id)
      );
      if (!exists) this.store.selectedAgency.push(item.raw ?? item);
      if (!Array.isArray(this.store.data_meeting.agent_id))
        this.store.data_meeting.agent_id = [];
      if (!this.store.data_meeting.agent_id.includes(item.raw.id)) {
        this.store.data_meeting.agent_id.push(item.raw.id);
      }
    },
    async createMeeting(id) {
      // const activityId =
      //   this.store.meeting_id || this.store.data_meeting?.activity_id;

      // if (!activityId) {
      //   this.genaralStore.showSnackbar("Missing activity_id", "error");
      //   return;
      // }
      try {
        // جهّز الأرقام
        const numbersRaw = Array.isArray(this.store.data_meeting.number)
          ? this.store.data_meeting.number
          : this.store.data_meeting.phone
          ? [this.store.data_meeting.phone]
          : [];

        const numbers = numbersRaw
          .map((n) => (typeof n === "object" ? n?.phone : n))
          .map((v) => String(v || "").trim())
          .filter(Boolean);

        const form = new FormData();
        form.append("meeting_for", this.store.data_meeting.meeting_for || "");
        form.append("content", this.store.data_meeting.content || "");
        form.append(
          "from",
          this.store.data_meeting.from
            ? this.store.formatDateForMySQL(this.store.data_meeting.from)
            : ""
        );
        form.append(
          "to",
          this.store.data_meeting.to
            ? this.store.formatDateForMySQL(this.store.data_meeting.to)
            : ""
        );
        form.append("type", "Meeting");
        form.append("status", this.store.data_meeting.status || "");
        if (this.store.data_meeting.meeting_place)
          form.append("meeting_place", this.store.data_meeting.meeting_place);
        if (this.store.data_meeting.meeting_title)
          form.append("meeting_title", this.store.data_meeting.meeting_title);
        (this.store.data_meeting.agent_id || []).forEach((id, i) =>
          form.append(`agent_id[${i}]`, id)
        );

        // phones[0], phones[1], ... (flat)
        numbers.forEach((p, i) => form.append(`phones[${i}]`, p));

        await apiClient.post(`/leads-managment/overview/${id}`, form);

        this.store.meetingDialog = false;
        this.store.data_meeting = {};
        this.genaralStore.showSnackbar("Meeting created", "#237276");
        this.store.singleLeadData = [];
        this.store.getALead(this.$route.params.id);
      } catch (err) {
        console.error("Error creating meeting:", err?.msg || err);
        // this.genaralStore.showSnackbar(err?.msg?.data || "Error", "error");
      }
    },

    async editMeeting() {
      try {
        // جهّز الأرقام
        const numbersRaw = Array.isArray(this.store.data_meeting.number)
          ? this.store.data_meeting.number
          : this.store.data_meeting.phone
          ? [this.store.data_meeting.phone]
          : [];
        const numbers = numbersRaw
          .map((n) => (typeof n === "object" ? n?.phone : n))
          .map((v) => String(v || "").trim())
          .filter(Boolean);

        const form = new FormData();
        form.append("meeting_for", this.store.data_meeting.meeting_for || "");
        form.append("content", this.store.data_meeting.content || "");
        form.append(
          "from",
          this.store.data_meeting.from
            ? this.store.formatDateTime(this.store.data_meeting.from)
            : ""
        );
        form.append(
          "to",
          this.store.data_meeting.to
            ? this.store.formatDateTime(this.store.data_meeting.to)
            : ""
        );
        form.append("type", "Meeting");
        form.append("status", this.store.data_meeting.status || "");
        if (this.store.data_meeting.meeting_place)
          form.append("meeting_place", this.store.data_meeting.meeting_place);
        if (this.store.data_meeting.meeting_title)
          form.append("meeting_title", this.store.data_meeting.meeting_title);
        (this.store.data_meeting.agent_id || []).forEach((id, i) =>
          form.append(`agent_id[${i}]`, id)
        );
        numbers.forEach((p, i) => form.append(`phones[${i}]`, p));

        const res = await apiClient.post(
          `/leads-managment/update-overview/${
            this.store.meeting_id || this.store.call_id
          }`,
          form,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        await this.store.getAleadForEdit?.();
        this.store.meetingDialog = false;
        this.store.data_meeting = {};
        this.genaralStore.showSnackbar(
          res.data?.msg || "Meeting updated",
          "#237276"
        );
      } catch (err) {
        console.error("Error editing meeting:", err?.msg || err);
        // this.genaralStore.showSnackbar(err?.msg?.data || "Error", "error");
      }
    },
    // حوّل أي input لـ Array of {phone}
    toPhoneObjects(input) {
      if (!input) return [];
      if (typeof input === "string") {
        try {
          input = JSON.parse(input);
        } catch {
          input = [input];
        }
      }
      const arr = Array.isArray(input) ? input : [input];
      return arr
        .map((v) => {
          if (typeof v === "string") return { phone: v.trim() };
          if (v && typeof v === "object") {
            const p =
              v.phone ?? v.value ?? v.number ?? v.mobile ?? v?.raw?.phone ?? "";
            return p ? { phone: String(p).trim() } : null;
          }
          return null;
        })
        .filter(Boolean);
    },

    // رجّع أرقام كـ strings مسطّحة (من list أو من phone واحد)
    phonesFrom(obj, listKey = "number", singleKey = "phone") {
      const list = Array.isArray(obj?.[listKey]) ? obj[listKey] : [];
      const fromArray = list
        .map((n) => (typeof n === "object" ? n?.phone : n))
        .map((v) => String(v || "").trim())
        .filter(Boolean);
      const fromSingle = obj?.[singleKey]
        ? [String(obj[singleKey]).trim()]
        : [];
      return fromArray.length ? fromArray : fromSingle;
    },

    openEditMeetingDialog(meeting,leads_name) {
      console.log("➡️ meeting:", meeting,leads_name);

      const lead = this.store.singleLeadData || {};

      const fromDate = meeting?.not_parsed_from
        ? new Date(meeting.not_parsed_from)
        : null;
      const toDate = meeting?.not_parsed_to
        ? new Date(meeting.not_parsed_to)
        : null;

      this.store.meeting_id = meeting.activity_id;
      this.store.edit_dialog = true;

      // الاسم: خده من call_for (الموجود في الـ activity)
      const fullName = leads_name.first_name + " " + leads_name.last_name;
        

      // الأرقام: الـ activity غالبًا مافهوش numbers → استخدم أرقام الـ lead
      const rawPhones =
        (Array.isArray(meeting?.number) && meeting.number.length
          ? meeting.number
          : null) ??
        (Array.isArray(meeting?.phones) && meeting.phones.length
          ? meeting.phones
          : null) ??
        (Array.isArray(lead?.phones) && lead.phones.length
          ? lead.phones
          : null) ??
        (lead?.phone ? [lead.phone] : []);

      const numbers = this.toPhoneObjects(rawPhones); // [{phone: "..."}]

      this.store.data_meeting = {
        meeting_for: fullName,
        number: numbers, // multi للـ UI
        phone: numbers[0]?.phone || lead?.phone || "", // fallback لو رقم واحد
        content: meeting?.content ?? "",
        from: fromDate,
        to: toDate,
        agent_id: Array.isArray(meeting?.agent_id)
          ? meeting.agent_id
          : [meeting?.agent_id].filter(Boolean),
        status: meeting?.status ?? "",
        type: "Meeting",
        meeting_place: meeting?.meeting_place ?? "",
        meeting_title: meeting?.meeting_title ?? "",
      };

      this.store.meetingDialog = true;
    },
    removeAgency(item) {
      const id = item?.raw?.id ?? item?.id;

      // شيل من selectedAgency (لو Array)
      if (Array.isArray(this.store.selectedAgency)) {
        this.store.selectedAgency = this.store.selectedAgency.filter(
          (a) => (a.id ?? a.raw?.id) !== id
        );
        if (this.store.selectedAgency.length === 0) {
          // اختياري: لما تفضى خليها [] بدل null لتفادي أخطاء مشابهة
          this.store.selectedAgency = [];
        }
      } else {
        // لو Single لأي سبب
        this.store.selectedAgency = null;
      }

      // شيل من agent_id
      if (!Array.isArray(this.store.data_meeting.agent_id))
        this.store.data_meeting.agent_id = [];
      this.store.data_meeting.agent_id =
        this.store.data_meeting.agent_id.filter((x) => x !== id);
    },
    async editCall() {
      try {
        const numbers = this.store.phoneArrayFromDataCall(this.store.data_call);

        const form = new FormData();
        form.append("call_for", this.store.data_call.call_for ?? "");
        form.append("status", this.store.data_call.status ?? "");
        form.append("content", this.store.data_call.content ?? "");
        form.append(
          "from",
          this.store.data_call.from
            ? this.store.formatDateTime(this.store.data_call.from)
            : ""
        );
        form.append("type", "Call Summary");

        numbers.forEach((num, i) => {
          form.append(`phones[${i}]`, num); // flat: phones[0], phones[1]
        });

        const res = await apiClient.post(
          `/leads-managment/update-overview/${this.store.call_id}`,
          form,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        await this.store.getALead(this.$route.params.id);
        this.store.callDialog = false;
        this.genaralStore.showSnackbar(res.data.msg, "#237276");
      } catch (err) {
        console.error("Error editing call:",err);
        // this.genaralStore.showSnackbar(err?.msg || "Error", "error");
      }
    },
  },
  mounted() {
    this.store.getAgencies();
  },
  watch: {
    "store.singleLeadData": {
      handler() {
        // Meeting
        this.store.data_meeting.meeting_for = `${
          this.store.singleLeadData.first_name || ""
        } ${this.store.singleLeadData.last_name || ""}`.trim();

        // === Call ===
        const hasPhones =
          Array.isArray(this.store.singleLeadData.phones) &&
          this.store.singleLeadData.phones.length > 0;
        const raw = hasPhones
          ? this.store.singleLeadData.phones
          : this.store.singleLeadData.phone
          ? [this.store.singleLeadData.phone]
          : [];

        this.store.data_call.call_for = `${
          this.store.singleLeadData.first_name || ""
        } ${this.store.singleLeadData.last_name || ""}`.trim();

        this.store.data_call.number = this.store.normalizeToPhoneObjects(raw);
        this.store.data_call.phone =
          this.store.data_call.number[0]?.phone ||
          this.store.singleLeadData.phone ||
          "";
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.fw-600 {
  font-weight: 600;
}

.avatar-fallback {
  width: 100%;
  height: 100%;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: #e6f0f2; /* سماوي فاتح */
  color: #3a5566;
  font-weight: 600;
}

.review-text {
  margin: 0;
  line-height: 1.6;
  color: #666;
  font-size: 12px;
  font-weight: 400;
}

.review-text.collapsed {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* عدد الأسطر قبل "Show More" */
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #666;
  font-size: 12px;
  font-weight: 400;
}

.show-more-btn {
  background: transparent;
  border: none;
  color: #237276; /* teal-ish مثل "Show More" بالصورة */
  font-weight: 500;
  cursor: pointer;
  font-size: 14px;
}
</style>
